export default __webpack_public_path__ + "static/media/earphones11.336b5a75.jfif";